<template>
    <TransitionRoot :show="true" as="template" class="relative z-50">
        <Dialog>
            <TransitionChild
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black/30"/>
            </TransitionChild>
            <div class="fixed inset-0 flex items-center justify-center p-4">
                <TransitionChild
                    enter="duration-300 ease-out"
                    enter-from="opacity-0 scale-95"
                    enter-to="opacity-100 scale-100"
                    leave="duration-200 ease-in"
                    leave-from="opacity-100 scale-100"
                    leave-to="opacity-0 scale-95"
                >
                    <DialogPanel class="w-[21.5625rem] md:w-[27.5rem] rounded-3xl bg-white relative">
                        <div class="py-9 md:py-10 px-6 md:px-9">
                            <div class="mb-6">
                                <h1 class="text-xl md:text-2xl">
                                    Enter Confirmation Code
                                </h1>
                                <span class="font-rubik text-sm text-[#8D8B8F]">
                                        Code has been sent to {{ email }}
                                    </span>
                            </div>
                            <div>
                                <div class="flex flex-col pb-6  md:pb-5">
                                    <input-component v-model:model-value="confirmationCode" name="title"
                                                     :is-valid="!errorMessage"
                                                     :error-message="errorMessage"
                                    >Confirmation Code
                                    </input-component>
                                </div>
                            </div>
                            <div class="flex justify-end">
                                <div>
                                    <button
                                        class="relative text-green text-sm leading-[0.875rem] px-7 py-3 mr-6 hover:bg-light-green rounded"
                                        :class="{'pr-10':loadResend}"
                                        @click="resendCode()">
                                        Resend Code
                                        <span v-if="loadResend" class="absolute top-2 border-green animate-spin rounded-full border-r-transparent h-5 w-5 border-[3px] ml-1" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </span>
                                    </button>
                                </div>
                                <button
                                    class="bg-green px-7 py-3 text-white text-sm leading-[0.875rem] rounded hover:bg-green-hover"
                                    @click="$emit('submit', confirmationCode)">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </DialogPanel>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import {ref} from "vue";
import {useToast} from 'vue-toast-notification';
import InputComponent from '../components/InputComponent'
import {Dialog, DialogPanel, TransitionRoot, TransitionChild} from '@headlessui/vue';
import {useAuthStore} from "../store/auth";

const props            = defineProps(['errorMessage', 'email'])
const emit             = defineEmits(['submit']);
const confirmationCode = ref(null);
const loadResend       = ref(false);
const toast            = useToast();
const authStore        = useAuthStore();

function resendCode() {
    loadResend.value = true;
    authStore.sendConfirmationCode(true).then(response => {
        toast.success(response.data.message, {
            duration: 5000,
        })
    }).catch(error => {
        toast.error('Failed', {
            duration: 5000,
        });
    }).finally(() => {
        loadResend.value = false;
    })
}
</script>

